var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 19.9446V11.4446C4.5 10.1856 5.0928 8.99996 6.1 8.24455L11.3 4.34456C12.0111 3.81126 12.9889 3.81126 13.7 4.34456L18.9 8.24455C19.9073 8.99996 20.5 10.1856 20.5 11.4447V19.9447C20.5 21.0493 19.6046 21.9447 18.5 21.9447H16.2C15.6477 21.9447 15.2 21.4969 15.2 20.9447V17.4447C15.2 15.9053 13.9119 14.6669 12.3547 14.7485C10.8947 14.825 9.8 16.1355 9.8 17.5975V20.9447C9.8 21.4969 9.3523 21.9447 8.8 21.9447H6.5C5.3954 21.9447 4.5 21.0492 4.5 19.9446Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e97e7d969fb4954147578a2165e81a27.svg";
export { ForwardRef as ReactComponent };